<template>

  <div class="page">
    <div class="nav1">
      我的记录
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height:calc(100vh - 80px);background: #fff;">
      <div class="list">
        <!-- <van-cell v-for="item in list" :key="item.applyId" :title="item.applyId" /> -->

        <van-cell v-for="item in list" :key="item.applyId" is-link center :to="`/appointment/info?id=${item.applyId}`"
          :title="`${formmatTime(item.vistorStartTime)}~${formmatTime(item.vistorEndTime)}`"
          :value="statusObj[String(item.status)]" :label="item.remark">

          <template #label>
            {{ item.vistorEmployeeName }} {{ item.reason }}
          </template>
        </van-cell>


      </div>
      <div class="nodata" v-if="list && list.length === 0">
        <div class="iconfont icon-queshengye_zanwushuju" style="font-size:100px;color:#3a88f2"></div>
        暂无数据
      </div>
    </van-pull-refresh>

  </div>
</template>

<script>
import { NavBar, PullRefresh } from 'vant'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      statusObj: { '-10': '', '-2': '已取消', '-1': '不通过', '0': '待认证', '1': '审核中', '2': '审核中', '10': '已通过' },
      isLoading: false,
      loading: false,
      finished: false,
      error: null,
      empty: true,
      list: null
    }
  },
  mounted() {
    this.onLoad();
  },
  components: {
    'van-nav-bar': NavBar,
    'van-pull-refresh': PullRefresh
  },
  methods: {
    formmatTime(date) {
      return dayjs(date).format("MM-DD HH:mm")
    },
    onClickLeft() { },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.empty = null;
      this.list = []
      this.onLoad()
    },
    goInfo(record) {
      this.$router.go({ path: '/appointment/info', query: { id: record.applyId } })
    },
    onLoad() {

      this.axios
        .get('apply/list', { params: { current: 1, pageSize: 200 } })
        .then(res => {
          if (res.errorCode == 0) {

            this.list = [...res.data];

            this.loading = false
            this.isLoading = false
            this.finished = true



          } else {
            this.loading = false
            this.isLoading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })



    }
  }
}
</script>

<style scoped lang="less">
.page {
  min-height: 100vh;
  background: #3a88f2;
}

.list {
  .item {
    .header {
      line-height: 30px;

      span {
        float: right;
        padding: 0 10px;
      }
    }

    ::after {
      display: block;
      content: '';
      border-top: solid 1px #FFF;
      width: 100%;
    }
  }

}
</style>
